import Settings from "components/SettingsTab/Settings";

const SettingsPage: React.FC = () => {
  return <Settings />;
};

export default SettingsPage;
